export default __webpack_public_path__ + "static/media/opn.2b91d284.png";